import { all, call, put, takeLatest } from "redux-saga/effects";
import * as actions from "../slices/appointmentsSlice";

import appointmentsApis from "src/api/appointment";

import { common } from "src/types/index";
import { constants } from "src/constants/common";
import { handleApiRequest } from "../sagaHelper";

// get appointment details/list saga
const GetAppointmentsSaga = function* GetAppointmentsSaga({
  payload: { resolve, reject, payload },
}: {
  payload: any;
}) {
  try {
    const response: common.ResponseGenerator = yield call(
      appointmentsApis.getAppointmentList,
      payload
    );
    if (Number(response?.code) === -1) {
      throw new Error("Session Expire");
    } else if (Number(response?.code) === 0) {
      throw new Error(response?.message);
    } else if (!response) {
      throw new Error(constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG);
    }
    yield put(actions.getAppointmentsSuccess(response?.data));
    resolve(response);
  } catch (error) {
    yield put(
      actions.getAppointmentsError(
        error instanceof Error
          ? error?.message
          : constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG
      )
    );
    reject(error);
  }
};

// get appointment time slots saga
const GetAppointmentTimeSlotsSaga = function* GetAppointmentTimeSlotsSaga({
  payload: { resolve, reject, payload },
}: {
  payload: any;
}) {
  try {
    const response: common.ResponseGenerator = yield call(
      appointmentsApis.getAppointmentTimeSlots,
      payload
    );

    if (Number(response?.code) === -1) {
      throw new Error("Session Expire");
    } else if (Number(response?.code) === 0) {
      throw new Error(response?.message);
    } else if (!response) {
      throw new Error(constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG);
    }
    yield put(actions.getAppointmentTimeSlotsSuccess(response?.data));
    resolve(response);
  } catch (error) {
    yield put(
      actions.getAppointmentTimeSlotsError(
        error instanceof Error
          ? error?.message
          : constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG
      )
    );
    reject(error);
  }
};

// get coach list saga
const GetCoachListSaga = function* GetCoachListSaga({
  payload: { resolve, reject, payload },
}: {
  payload: any;
}) {
  try {
    const response: common.ResponseGenerator = yield call(
      appointmentsApis.getCoachList,
      payload
    );
    if (Number(response?.code) === -1) {
      throw new Error("Session Expire");
    } else if (Number(response?.code) === 0) {
      throw new Error(response?.message);
    } else if (!response) {
      throw new Error(constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG);
    }
    yield put(actions.getCoachListSuccess(response?.data));
    resolve(response);
  } catch (error) {
    yield put(
      actions.getCoachListError(
        error instanceof Error
          ? error?.message
          : constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG
      )
    );
    reject(error);
  }
};

// add appointment saga
const AddAppointmentSaga = function* AddAppointmentSaga({
  payload: { resolve, reject, payload },
}: {
  payload: any;
}) {
  try {
    const response: common.ResponseGenerator = yield call(
      appointmentsApis.addAppointment,
      payload
    );
    if (Number(response?.code) === -1) {
      throw new Error("Session Expire");
    } else if (Number(response?.code) === 0) {
      throw new Error(response?.message);
    } else if (!response) {
      throw new Error(constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG);
    }
    yield put(actions.addAppointmentSuccess(response?.data));
    resolve(response);
  } catch (error) {
    yield put(
      actions.addAppointmentError(
        error instanceof Error
          ? error?.message
          : constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG
      )
    );
    reject(error);
  }
};

// request cancellation saga
const RequestCancellationSaga = function* RequestCancellationSaga({
  payload: { resolve, reject, payload },
}: {
  payload: any;
}) {
  try {
    const response: common.ResponseGenerator = yield call(
      appointmentsApis.requestCancellation,
      payload
    );
    if (Number(response?.code) === -1) {
      throw new Error("Session Expire");
    } else if (Number(response?.code) === 0) {
      throw new Error(response?.message);
    } else if (!response) {
      throw new Error(constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG);
    }
    yield put(actions.requestCancellationSuccess(response?.data));
    resolve(response);
  } catch (error) {
    yield put(
      actions.requestCancellationError(
        error instanceof Error
          ? error?.message
          : constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG
      )
    );
    reject(error);
  }
};

// get latest consultation saga
const GetLatestConsultationSaga = function* GetLatestConsultationSaga({
  payload: { resolve, reject, payload },
}: {
  payload: any;
}) {
  yield handleApiRequest({
    api: appointmentsApis.getLatestConsultation,
    payload,
    successAction: actions.getLatestConsultationSuccess,
    errorAction: actions.getLatestConsultationError,
    resolve,
    reject,
  });
};

export default function* appointmentSaga() {
  yield all([
    takeLatest(actions.getAppointmentsRequest, GetAppointmentsSaga),
    takeLatest(
      actions.getAppointmentTimeSlotsRequest,
      GetAppointmentTimeSlotsSaga
    ),
    takeLatest(actions.getCoachListRequest, GetCoachListSaga),
    takeLatest(actions.addAppointmentRequest, AddAppointmentSaga),
    takeLatest(actions.requestCancellationRequest, RequestCancellationSaga),
    takeLatest(actions.getLatestConsultationRequest, GetLatestConsultationSaga),
  ]);
}
